<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    destroy-on-close
    :append-to-body="appendToBody"
    :modal-append-to-body="appendToBody"
    @close="$emit('close')"
    width="1000px"
  >
    <template #title>
      <div class="d-flex justify-content-between">
        <div style="display: flex; align-items: center; justify-content: space-between">
          <strong style="font-size: 16px; margin-right: 10px; color: #42444d"
            >Chỉnh sửa quy trình</strong
          >
        </div>
            <el-popover
              v-if="internalFormData.processFiles.length > 0"
              placement="bottom-start"
              trigger="click"
              width="360"
              popper-class="file-popover"
              ref="popper"
            >
              <!-- CONTENT -->
              <div class="file-container">
                <div class="file-header px-2 pb-2">
                  <span class="title d-flex">
                    <div class="file-icon me-2">
                      <img src="@/assets/icons/file.png" />
                    </div>
                    <div> Quy trình {{ internalFormData.name }}</div>
                  </span>
                  <span class="close-btn" style="cursor: pointer;" @click="$refs.popper?.doClose()">✕</span>
                </div>

                <div class="file-list">
                  <div
                    v-for="(file, index) in internalFormData.processFiles"
                    :key="index"
                    class="file-item"
                  >
                    <div class="file-icon">
                      <img :src="getFileIcon(file)" />
                    </div>

                    <div class="file-info">
                      <div class="file-name">{{ getFileName(file) }}</div>
                      <div class="file-meta">
                        {{ formatDate(file.createAt) }}
                      </div>
                    </div>

                    <div class="file-actions">
                      <div style="cursor: pointer;" @click="previewFile(file)">
                        <IconFont
                          v-if="!isImage(file)"
                          class="font-size-16"
                          :size="'lg'"
                          :color="'grey'"
                          :name="'icon-export'"
                        />
                        <IconFont
                          v-else
                          class="font-size-16"
                          name="el-icon-view"
                          :size="'lg'"
                          :color="'grey'"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- BUTTON -->
              <template #reference>
                <div class="file-preview me-2">
                  <span>Tài liệu đính kèm</span>
                  <span class="file-count">
                    ({{ internalFormData.processFiles?.length }})
                  </span>
                </div>
              </template>
            </el-popover>
        <div v-if="appendToBody">
          <el-button
            icon="el-icon-plus"
            plain
            @click="navigateToFieldSetup"
            style="font-size: 14px; margin-left: 60px"
            >Thêm trường dữ liệu</el-button
          >
        </div>
      </div>
    </template>
    <div class="d-flex justify-content-between" style="background-color: #fafafa">
      <div class="ms-3 mb-2 mt-1">
        <ValidationObserver ref="obs">
          <div class="mt-2 required">Tên quy trình</div>
          <ValidationProvider
            name="Tên quy trình"
            rules="required-input: tên quy trình"
            v-slot="{ errors }"
          >
            <el-input
              class="counter-pad"
              maxlength="200"
              show-word-limit
              v-model="internalFormData.name"
              style="width: 320px"
              placeholder="Nhập tên quy trình"
            />
            <div v-if="errors[0]" class="mt-1 ms-1">
              <InputError :message="errors[0]" />
            </div>
          </ValidationProvider>
        </ValidationObserver>
      </div>
      <div class="me-2 mb-2 mt-1">
        <div class="mt-2">Mô tả</div>
        <el-input
          class="counter-pad"
          maxlength="256"
          show-word-limit
          v-model="internalFormData.description"
          style="width: 560px"
          placeholder="Mô tả quy trình"
        />
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <div class="process ms-3 mt-1">
        <div
          class="d-flex justify-content-between mt-2 ms-2 me-2 mb-2 align-items-center"
        >
          <div class="required d-flex align-items-center">
            Bước quy trình
            <el-tooltip placement="top">
              <div slot="content">
                <strong>Đang xử lý:</strong> Khách đang xử lý, chưa có kết quả<br/>
                <strong>Thành công:</strong> Chốt thành công, tối đa 1 bước<br/>
                <strong>Thất bại:</strong> Từ chối / mất liên lạc
              </div>
              <i class="el-icon-question text-muted ms-1" style="font-size: 14px; cursor: pointer;"></i>
            </el-tooltip>
          </div>
          <button class="custom-button-add" @click="addSteps">
            <icon-font
              :name="'icon-add'"
              :color="'white'"
              style="font-size: 13px"
            ></icon-font>
          </button>
        </div>
        <div style="max-height: 200px; overflow-y: auto">
          <draggable
            v-model="internalFormData.workflowList"
            handle=".drag-handle"
            tag="div"
            animation="200"
            @end="updateIndexes"
          >
            <div
              v-for="(workflow, index) in internalFormData.workflowList"
              :key="workflow.index"
            >
              <ValidationObserver ref="obs">
                <ValidationProvider
                  name="Tên bước"
                  rules="required-input: tên bước"
                  v-slot="{ errors }"
                >
                  <div class="mb-2">
                    <div class="w-100 d-flex align-items-center">
                      <div class="drag-handle ms-2" style="cursor: pointer">
                        <IconFont :name="'icon-organise'" />
                      </div>
                      <div class="custom-item ms-2">
                        <div
                          class="circle"
                          :class="{
                            active: activeIndex === index,
                            value: workflow.title,
                            bolded: boldedIndexes.includes(index),
                          }"
                          style="cursor: pointer"
                          @click.stop="toggleBolded(index)"
                        >
                          {{ workflow.index }}
                        </div>
                      </div>
                      <div
                        class="d-flex justify-content-between custom-input ms-2"
                        :class="{ 'active-input': activeIndex === index }"
                      >
                        <div
                          style="
                            position: relative;
                            border: none;
                            background: transparent;
                            flex-grow: 1;
                            display: flex;
                            align-items: center;
                          "
                        >
                          <input
                            placeholder="Nhập tên bước"
                            class="custom-input1"
                            v-model="workflow.title"
                            style="border: none; outline: none; background: transparent; padding-right: 70px;"
                            @focus="activeIndex = index"
                            @input="workflow.title = workflow.title.slice(0, 200)"
                            maxlength="200"
                          />
                          <span class="char-counter" style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%);">
                            {{ workflow.title.length }}/200
                          </span>
                        </div>
                        <el-select
                          v-model="workflow.milestoneType"
                          size="mini"
                          clearable
                          placeholder="Chọn nhóm"
                          style="width: 120px; margin-right: 15px; position: relative; top: -2px;"
                          :class="'milestone-select-' + (workflow.milestoneType || 'EMPTY')"
                          @change="(val) => handleMilestoneChange(index, val || null, internalFormData.workflowList)"
                          @clear="handleMilestoneChange(index, null, internalFormData.workflowList)"
                          :disabled="index === 0"
                          :popper-append-to-body="appendToBody"
                        >
                          <el-option label="Đang xử lý" value="OPEN" class="bg-open-option" />
                          <el-option label="Thành công" value="WON" class="bg-won-option" />
                          <el-option label="Thất bại" value="LOST" class="bg-lost-option" />
                        </el-select>
                        <div class="color-picker">
                          <el-dropdown trigger="click">
                            <button class="custom">
                              <div
                                class="selected-color"
                                :style="{
                                  backgroundColor: workflow.color,
                                }"
                              ></div>
                            </button>
                            <el-dropdown-menu slot="dropdown">
                              <div class="color-container">
                                <div
                                  v-for="color in colors"
                                  :key="color"
                                  @click="handleSelect(color, workflow)"
                                  class="color-box"
                                  :style="{
                                    backgroundColor: color,
                                    color: getTextColor(color),
                                  }"
                                ></div>
                              </div>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>
                      </div>
                      <button
                        @click="removeSteps(index)"
                        style="
                          background-color: transparent;
                          border: none;
                          cursor: pointer;
                        "
                      >
                        <icon-font :name="'icon-close'"></icon-font>
                      </button>
                    </div>
                    <div v-if="errors[0]" class="mb-1" style="margin-left: 87px">
                      <InputError :message="errors[0]" />
                    </div>
                  </div>
                </ValidationProvider>
              </ValidationObserver>
            </div>
          </draggable>
        </div>
        <div class="ms-2 mb-2 mt-3 d-flex align-items-center legend-container" style="font-size: 13px; color: #696b72; font-weight: 500;">
           <div class="legend-item d-flex align-items-center"><span class="legend-dot bg-open-dot"></span> Đang xử lý</div>
           <div class="legend-item d-flex align-items-center ms-3"><span class="legend-dot bg-won-dot"></span> Thành công (tối đa 1)</div>
           <div class="legend-item d-flex align-items-center ms-3"><span class="legend-dot bg-lost-dot"></span> Thất bại</div>
        </div>
      </div>
      <div class="information-file me-2 mt-1">
        <div class="d-flex flex-column ms-2">
          <ValidationObserver ref="obs">
            <div
              class="d-flex justify-content-between align-items-center mt-2"
              style="font-size: 14px"
            >
              <div class="required">Trường dữ liệu</div>
              <div class="me-2">
                {{ columnListLength }}
              </div>
            </div>
            <ValidationProvider
              name="Trường dữ liệu"
              rules="required-select: trường dữ liệu"
              v-slot="{ errors }"
            >
              <div style="max-height: 200px; overflow-y: auto">
                <el-checkbox-group
                  v-if="internalFormData?.workflowList[displayIndex]"
                  v-model="selectedColumnList"
                  class="checkbox-vertical"
                >
                  <el-checkbox
                    v-for="info in columnList.filter(c => !['createAt', 'contactWorkflow'].includes(c.name))"
                    :key="info.name"
                    :label="info.name"
                    :disabled="info.name ==='displayName' || info.name ==='phone'"
                  >
                    {{ info.title }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <div v-if="errors[0]" class="mt-1 ms-4">
                <InputError :message="errors[0]" />
              </div>
            </ValidationProvider>
          </ValidationObserver>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-end">
      <div class="d-flex mt-2" style="margin-right: 15px; margin-bottom: 8px">
        <el-button @click="$emit('close')" plain>Hủy</el-button>
        <el-button
          type="primary"
          @click="submit"
          :disabled="
            !internalFormData.name ||
            internalFormData.workflowList.length == 0 ||
            internalFormData.workflowList.some((wf) => !wf.title?.trim()) ||
            internalFormData.workflowList.some((cl) => !cl.columnList?.length)
          "
          >Cập nhật quy trình</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import workflow from "@/lib/apis/workflow";
import draggable from "vuedraggable";
import { HTTP } from "@/lib/http-common";
import iconPdf from '@/assets/icons/pdf.png';
import iconWord from '@/assets/icons/word.png';
import iconExcel from '@/assets/icons/sheets.png';
import iconPpt from '@/assets/icons/ppt.png';
import iconImage from '@/assets/icons/image.png';
import iconZip from '@/assets/icons/zip.png';
import iconFile from '@/assets/icons/file.png';

export default {
  beforeDestroy() {
    this.dialogVisible = false;
  },
  props: {
    formData: { default: null },
    steps: { default: null },
    appendToBody: { type: Boolean, default: true }
  },
  components: {
    draggable,
  },
  data() {
    return {
      dialogVisible: true,
      dialogCreateField: false,
      internalFormData: {},
      colors: [
        "#5692AD",
        "#D08B20",
        "#0A58C0",
        "#DD7236",
        "#598C78",
        "#B666AA",
        "#3A4660",
        "#466D34",
        "#C84837",
        "#7053B4",
      ],
      availableFields: [],
      activeIndex: 0,
      boldedIndexes: [],
    };
  },

  created() {
  },

  mounted() {
    this.internalFormData = JSON.parse(JSON.stringify(this.formData));
    this.internalFormData.workflowList.forEach((workflow, index) => {
      workflow.columnList = JSON.parse(workflow.columnList);
      if (index === 0 && !workflow.milestoneType) {
        workflow.milestoneType = 'OPEN';
      }
    });
    this.internalFormData.workflowList.sort((a, b) => a.index - b.index);
  },
  methods: {
    openFile(file) {
      if (file) {
        window.open(file.url, "_blank");
      } else {
        console.error("Không tìm thấy file:", file.id);
      }
    },
    getFileName(file) {
      return file ? file.fileName : "Không tìm thấy file";
    },
    getFileExt(file) {
      if (!file?.fileName) return '';
      return file.fileName.split('.').pop().toLowerCase();
    },
    getFileIcon(file) {
      const ext = this.getFileExt(file);

      const map = {
        pdf: iconPdf,

        doc: iconWord,
        docx: iconWord,
        txt: iconWord,

        xls: iconExcel,
        xlsx: iconExcel,
        csv: iconExcel,

        ppt: iconPpt,
        pptx: iconPpt,

        jpg: iconImage,
        jpeg: iconImage,
        png: iconImage,
        gif: iconImage,

        zip: iconZip,
        rar: iconZip
      };

      return map[ext] || iconFile;
    },
    formatDate(date) {
      const d = new Date(date);
      return d.toLocaleDateString('vi-VN');
    },
    previewFile(file) {
      window.open(file.url, '_blank');
    },
    isImage(file) {
      const ext = this.getFileExt(file);
      return ['jpg', 'jpeg', 'png', 'gif', 'pdf'].includes(ext);
    },
    async submit() {
      try {
        const checkWon = this.internalFormData.workflowList.filter(wf => wf.milestoneType === 'WON');
        if (checkWon.length === 0) {
          this.$message.warning("Mỗi quy trình phải có ít nhất 1 bước có Nhóm trạng thái (Milestone) là 'Thành công'.");
          return;
        }

        const titles = this.internalFormData.workflowList.map((item) => item.title.trim());
        const hasDuplicateTitles = titles.some(
          (title, index) => titles.indexOf(title) !== index
        );
        if (hasDuplicateTitles) {
          this.$message.error("Tên bước đã bị trùng. Vui lòng thử lại.");
          return;
        }
        const res = await HTTP.post("/api/process/update-process", this.internalFormData);
        if (res.status === "success") {
          this.$message.success("Cập nhật quy trình thành công!");
          this.$emit("close");
          this.$emit("success");
        } else {
          this.$message.error(res.error.message);
        }
      } catch (error) {
        console.error("Error create process", error);
      }
    },
    getTextColor(bgColor) {
      return this.isDark(bgColor) ? "#ffffff" : "#000000";
    },
    isDark(color) {
      const r = parseInt(color.substr(1, 2), 16);
      const g = parseInt(color.substr(3, 2), 16);
      const b = parseInt(color.substr(5, 2), 16);
      return r * 0.299 + g * 0.587 + b * 0.114 < 128;
    },
    updateIndexes() {
      this.internalFormData.workflowList.forEach((workflow, i) => {
        workflow.index = i + 1;
      });
    },
    handleMilestoneChange(index, newVal, workflowList) {
      const normalizedVal = newVal ? newVal : null;
      workflowList[index].milestoneType = normalizedVal;
      if (newVal === 'WON') {
        workflowList.forEach((wf, i) => {
          if (i !== index && wf.milestoneType === 'WON') {
            wf.milestoneType = 'OPEN';
          }
        });
      }
    },
    handleSelect(color, workflow) {
      workflow.color = color;
    },
    removeSteps(index) {
      const removedItem = this.internalFormData.workflowList[index];
      if (removedItem.id) {
        this.deleteWorkflow(removedItem.id, index);
      } else {
        this.internalFormData.workflowList.splice(index, 1);
        this.internalFormData.workflowList.forEach((item, i) => {
          item.index = i + 1;
        });
        this.syncIndexesAfterRemove(index);
      }
    },

    async deleteWorkflow(workflow, index) {
      try {
        const res = await HTTP.post(
          `/api/process/delete-workflow?workflowId=${workflow}`
        );
        if (res.status === "success") {
          this.internalFormData.workflowList.splice(index, 1);
          this.internalFormData.workflowList.forEach((item, i) => {
            item.index = i + 1;
          });
          this.syncIndexesAfterRemove(index);
          this.$message.success("Xóa bước thành công!");
        } else {
          this.$message.error(res.error.message);
        }
      } catch (error) {
        this.$message.error("Có lỗi xảy ra khi xóa bước!");
      }
    },
    syncIndexesAfterRemove(index) {
      this.boldedIndexes = this.boldedIndexes
        .filter((i) => i !== index)
        .map((i) => (i > index ? i - 1 : i));
      if (this.activeIndex === index) {
        this.activeIndex = Math.max(0, index - 1);
      } else if (this.activeIndex > index) {
        this.activeIndex -= 1;
      }
    },
    toggleBolded(index) {
      const pos = this.boldedIndexes.indexOf(index);
      if (pos === -1) {
        this.boldedIndexes = [...this.boldedIndexes, index];
      } else {
        this.boldedIndexes = this.boldedIndexes.filter((i) => i !== index);
      }
    },
    addSteps() {
      const maxIndex = this.internalFormData.workflowList.length
        ? Math.max(...this.internalFormData.workflowList.map((item) => item.index))
        : 0;
        // const requiredColumns = this.columnList
        // .filter((col) => col.require)
        // .map((col) => col.name);  
      this.internalFormData.workflowList.push({
        title: "",
        color: this.colors[Math.floor(Math.random() * this.colors.length)],
        index: maxIndex + 1,
        columnList:['displayName','phone'],
        milestoneType: null
        // columnList: requiredColumns,
      });
    },
    navigateToFieldSetup() {
      this.$emit("navigate");
    },
    updateColumnList(newValue) {
      this.internalFormData.workflowList[this.activeIndex].columnList = JSON.stringify(
        newValue
      );
    },
    getVisibleSteps() {
      const visibleSteps = [];
      const maxVisibleSteps = 10;
      const index = this.internalFormData.index || 0;
      if (index <= maxVisibleSteps) {
        for (let i = 1; i <= maxVisibleSteps; i++) {
          visibleSteps.push(i);
        }
      } else {
        visibleSteps.push(1, 2, 3, 4);
        visibleSteps.push("...");
        for (let i = index - 4; i <= index; i++) {
          visibleSteps.push(i);
        }
      }
      return visibleSteps;
    },
    handleColorClick(color) {
      this.internalFormData.color = color;
    },
    async submitForm() {
      try {
        const code = this.formData.code;
        const duplicate = this.steps.find(
          (item) =>
            item.title === this.internalFormData.title &&
            item.title !== this.formData.title
        );
        if (duplicate) {
          const confirm = await this.$confirm(
            `Tên trường dữ liệu đã tồn tại trong hệ thống. Bạn có chắc chắn tiếp tục lưu?`,
            "Xác nhận",
            {
              confirmButtonText: "Lưu",
              cancelButtonText: "Hủy",
              type: "warning",
              dangerouslyUseHTMLString: true,
            }
          ).catch(() => null);

          if (!confirm) {
            return;
          }
        }
        const response = await workflow.editWorkflow(code, this.internalFormData);
        if (response.status === "success") {
          const updatedWorkflow = response.data;
          updatedWorkflow.informationField = JSON.parse(updatedWorkflow.informationField);
          const index = this.app.workflowList.findIndex(
            (workflow) => workflow.id === updatedWorkflow.id
          );

          if (index !== -1) {
            this.$set(this.app.workflowList, index, updatedWorkflow);
            this.$message.success("Cập nhật bước thành công!");
            this.$emit("update-step", response.data);
            this.$emit("close-dialog");
          }
        } else {
          this.$message.error(response.error.message);
        }
      } catch (error) {
        if (error) {
          const errorMessage = error.error.message;
          if (errorMessage.includes("Code Existed")) {
            this.$message.error("Mã bước đã tồn tại.");
          }
          if (errorMessage === "Title Existed") {
            this.$message.error("Tên bước đã tồn tại.");
          }
        } else {
          this.$message.error("Lỗi kết nối đến máy chủ. Vui lòng kiểm tra lại.");
        }
      }
    },
    getFieldLabel(value) {
      const field = this.availableFields.find((f) => f.value === value);
      return field ? field.label : "";
    },
  },
  computed: {
    displayIndex() {
      if (this.boldedIndexes.length && this.boldedIndexes.includes(this.activeIndex)) {
        return Math.min(...this.boldedIndexes);
      }
      return this.activeIndex;
    },
    selectedColumnList: {
      get() {
        return this.internalFormData.workflowList[this.displayIndex]?.columnList || [];
      },
      set(newList) {
        const next = Array.isArray(newList) ? newList : [];
        if (this.boldedIndexes.length && this.boldedIndexes.includes(this.activeIndex)) {
          this.boldedIndexes.forEach((idx) => {
            if (this.internalFormData.workflowList[idx]) {
              this.$set(this.internalFormData.workflowList[idx], 'columnList', [...next]);
            }
          });
        } else if (this.internalFormData.workflowList[this.activeIndex]) {
          this.$set(this.internalFormData.workflowList[this.activeIndex], 'columnList', [...next]);
        }
      },
    },
    columnListLength() {
      const columnList = this.internalFormData.workflowList[this.displayIndex]?.columnList;
      return columnList ? columnList.length : 0;
    },
    tooltipContent() {
      if (this.internalFormData.informationField) {
        return (
          this.internalFormData.informationField
            .map((field) => this.getFieldLabel(field))
            .join(", ") || "Chưa chọn trường"
        );
      }
      return "";
    },
  },
};
</script>

<style scoped>
.tag-option {
  cursor: pointer;
  margin-right: 2px;
}

.selected-tag-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.step-button {
  width: 36px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  margin-right: 6px;
  background-color: white;
  color: #327ae7;
  border: 1px solid #327ae7;
  border-radius: 4px;
}

.step-button:disabled {
  background-color: #e0e0e0;
  color: #a0a0a0;
  cursor: not-allowed;
  border: none !important;
}

/* .custom {
  margin-left: 20px;
  margin-right: 15px;
  font-size: 14px;
} */
.el-input[readonly] {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.disabled-text {
  color: #c0c0c0;
  opacity: 0.6;
}
.custom-button-add {
  background-color: #1769d7;
  border: none;
  border-radius: 50%;
  width: 17px;
  height: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  border: 1px solid #cf4343;
  background-color: white;
  color: #696b72;
}
.custom {
  border: none;
  background: none;
}
.selected-color {
  width: 20px;
  height: 20px;
  border-radius: 4px;
}
.color-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-width: 150px;
  margin-left: 10px;
}
.process {
  width: 660px;
  border-radius: 4px;
  border: 1px solid #dcdfe9;
}
.custom-input {
  width: 560px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 6px;
  outline: none;
  padding: 8px;
}
.counter-pad >>> .el-input__inner {
  padding-right: 60px;
}
.active {
  background-color: #327ae7;
  border: 1px solid #4b9e77;
  color: white;
  font-size: 16px;
}
.value {
  background-color: white;
  border: 1px solid #4b9e77;
  color: #696b72;
  font-size: 16px;
}
.circle.bolded {
  border: 2px solid #0a58c0;
  color: #0a58c0;
  font-weight: 900;
}
.circle.bolded.active {
  background-color: #327ae7;
  color: white;
  border: 2px solid #0a58c0;
}
.color-box {
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 40px;
  border-radius: 4px;
  font-weight: bold;
}
.checkbox-vertical {
  display: flex;
  flex-direction: column;
}
.information-file {
  width: 280px;
  border-radius: 4px;
  border: 1px solid #dcdfe9;
}
.custom-input.active-input {
  border: 1px solid #327ae7;
}
.custom-input1 {
  border: none;
  outline: none;
  border-radius: 4px;
  padding-right: 50px;
  background: #fff;
  width: 100%;
  box-sizing: border-box;
}
.char-counter {
  display: flex;
  align-items: center;
  right: 5px;
  top: 50%;
  color: #666;
  font-size: 12px;
}
.file-preview {
  background-color: #d4e4ffad;
  color: #327ae7;
  border-radius: 10px;
  max-width: 170px;
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.file-count {
  margin-left: 4px;
}

.file-popover {
  padding: 0 !important;
  border-radius: 8px;
}

.file-container {
  width: 100%;
  max-height: 360px;
  display: flex;
  flex-direction: column;
}

.file-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  font-weight: 600;
}

.file-list {
  max-height: 300px;
  overflow-y: auto;
}

.file-item {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  gap: 10px;
  border-bottom: 1px solid #f1f1f1;
}

.file-item:hover {
  background: #f7f9fc;
}

.file-icon img {
  width: 18px;
  height: 18px;
}

.file-info {
  flex: 1;
}

.file-name {
  font-weight: 500;
  font-size: 14px;
}

.file-meta {
  font-size: 12px;
  color: #888;
}

.file-actions i {
  cursor: pointer;
  font-size: 18px;
  margin-left: 8px;
  color: #666;
}

.file-actions i:hover {
  color: #409eff;
}

.file-count {
  color: #666;
}

.title {
  max-width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
}
</style>

<style>
.milestone-select-EMPTY .el-input__inner { background-color: #f5f5f5 !important; color: #a0a0a0 !important; border: 1px solid #dcdfe9 !important; font-weight: 400; padding: 0 10px; height: 26px !important; line-height: 24px !important; }
.milestone-select-OPEN .el-input__inner { background-color: #e1edfd !important; color: #176ad7 !important; border: 1px solid transparent !important; font-weight: 500; padding: 0 10px; height: 26px !important; line-height: 24px !important; }
.milestone-select-WON .el-input__inner { background-color: #e6f7eb !important; color: #1e8e3e !important; border: 1px solid transparent !important; font-weight: 500; padding: 0 10px; height: 26px !important; line-height: 24px !important; }
.milestone-select-LOST .el-input__inner { background-color: #ffeced !important; color: #d93025 !important; border: 1px solid transparent !important; font-weight: 500; padding: 0 10px; height: 26px !important; line-height: 24px !important; }
.milestone-select-EMPTY .el-input__icon, .milestone-select-OPEN .el-input__icon, .milestone-select-WON .el-input__icon, .milestone-select-LOST .el-input__icon { line-height: 26px !important; }
.bg-open-option { color: #176ad7 !important; font-weight: 500; }
.bg-won-option { color: #1e8e3e !important; font-weight: 500; }
.bg-lost-option { color: #d93025 !important; font-weight: 500; }
.legend-dot { display: inline-block; width: 12px; height: 12px; border-radius: 2px; margin-right: 6px; border: 1px solid #cfced4; }
.bg-open-dot { background-color: #e1edfd; border: 1px solid #85b1ff; }
.bg-won-dot { background-color: #e6f7eb; border: 1px solid #5bb974; }
.bg-lost-dot { background-color: #ffeced; border: 1px solid #f28b82; }
</style>
